import React from 'react';
import s from './Comments.scss';
import Comments from '../../components/Comments';

class CommentsNonPrime extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return <Comments {...this.props} styles={s} />;
  }
}

export default CommentsNonPrime;
